import { create } from 'zustand';
import { getPaymentVoucherTodo, type PaymentVoucherTodo } from '@/services/paymentVoucherTodo';

export const usePaymentVoucherTodoStore = create<{
  context: string | null;
  todo: PaymentVoucherTodo | null;
  error: boolean;
}>(() => ({ context: null, todo: null, error: false }));

let generation = 0;
let pending: Promise<void> | null = null;

export function setPaymentVoucherTodoContext(context: string | null) {
  if (usePaymentVoucherTodoStore.getState().context === context) return;
  generation += 1;
  pending = null;
  usePaymentVoucherTodoStore.setState({ context, todo: null, error: false });
}

export function refreshPaymentVoucherTodo(force = false): Promise<void> {
  if (!usePaymentVoucherTodoStore.getState().context) return Promise.resolve();
  if (force) {
    generation += 1;
    pending = null;
  }
  if (pending) return pending;
  const revision = generation;
  const promise = getPaymentVoucherTodo()
    .then((todo) => {
      if (revision !== generation) return;
      usePaymentVoucherTodoStore.setState({
        todo: todo.scope === 'self' || todo.scope === 'team' ? todo : null,
        error: false,
      });
    })
    .catch(() => {
      if (revision === generation) usePaymentVoucherTodoStore.setState({ error: true });
    })
    .finally(() => {
      if (pending === promise) pending = null;
    });
  pending = promise;
  return promise;
}
